import { render, staticRenderFns } from "./Tema11.vue?vue&type=template&id=52810cc1&lang=pug"
import script from "./Tema11.vue?vue&type=script&lang=js"
export * from "./Tema11.vue?vue&type=script&lang=js"
import style0 from "./Tema11.vue?vue&type=style&index=0&id=52810cc1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports